<template>
  <button
    class="flex h-9 cursor-pointer items-center justify-center px-2 rounded-md bg-white bg-opacity-20 hover:bg-opacity-25"
  >
    <slot />
  </button>
</template>

<script lang="ts" setup></script>
